const lbaFileUploader = angular.module('app.lbaFileUploader', []);

lbaFileUploader.controller('lbaFileUploaderCtrl', require('./lbaFileUploaderCtrl'));
lbaFileUploader.directive('lbaFileUploader', require('./lbaFileUploaderDir'));

export default lbaFileUploader;



// WEBPACK FOOTER //
// ./src/components/lbaFileUploader/index.js